import styled, { keyframes } from "styled-components";

export const FREE_TEXT_GRADIENT_BG =
    "linear-gradient(90deg, rgba(255, 87, 211, 0.06) 1.52%, rgba(252, 200, 239, 0.06) 58.84%, rgba(255, 255, 255, 0.06) 98.63%)";

const SHIMMER_DEFAULT_DURATION = "4s";
const SHIMMER_DEFAULT_COLOR =
    "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.65) 25%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.65) 75%, rgba(255, 255, 255, 0) 100%)";

const SHIMMER_DEFAULT_BAND_WIDTH = "24px";

const SEPARATOR_DEFAULT_GRADIENT = "linear-gradient(90deg, #D9DADB -43.58%, rgba(217, 218, 219, 0.00) 98.39%)";

const shimmerSweep = keyframes`
    0% {
        transform: translateX(-20%);
    }
    55%,
    100% {
        transform: translateX(120%);
    }
`;

export const FreeTextContainer = styled.div<{ backgroundColor?: string }>`
    position: relative;
    isolation: isolate;
    overflow: hidden;
    display: flex;
    margin: 16px -16px 0;
    padding: ${({ theme }) => `${theme.spacing.xxSmall} ${theme.spacing.medium}`};
    background: ${({ backgroundColor }) => backgroundColor || "none"};
`;

export const ShimmerSweep = styled.div<{ sweepDuration?: string }>`
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 1px;
    mix-blend-mode: overlay;
    pointer-events: none;
    animation: ${shimmerSweep} ${({ sweepDuration }) => sweepDuration || SHIMMER_DEFAULT_DURATION} ease-in-out infinite;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
        opacity: 0;
    }
`;

export const ShimmerBand = styled.span<{ bandColor?: string; bandWidth?: string }>`
    flex-shrink: 0;
    width: ${({ bandWidth }) => bandWidth || SHIMMER_DEFAULT_BAND_WIDTH};
    height: 70px;
    transform: rotate(27deg);
    background: ${({ bandColor }) => bandColor || SHIMMER_DEFAULT_COLOR};
`;

export const FreeTextContent = styled.div`
    position: relative;
    z-index: 1;
`;

export const FadedSeparator = styled.div<{ gradient?: string }>`
    height: 1px;
    margin: ${({ theme }) => `0 -16px ${theme.spacing.xxSmall}`};
    background: ${({ gradient }) => gradient || SEPARATOR_DEFAULT_GRADIENT};
`;
